import { gql } from '@apollo/client';

const UPDATE_STUDY_SETTING_MUTATION = gql`
  mutation updateStudySetting($input: UpdateStudySettingInput) {
    updateStudySetting(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_SETTING_MUTATION;
